/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#comments[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]{padding-top:1rem;padding-bottom:1rem;border-bottom:1px solid #dee2e6}#comments[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]:last-child{border:0 none}#comments[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:block}#comments[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]   span.commenter[_ngcontent-%COMP%]{font-weight:700;font-size:110%}#comments[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]   span.date[_ngcontent-%COMP%]{color:#495057;font-style:italic}#comments[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]   span.text[_ngcontent-%COMP%]{margin-top:1rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/comment/comment.component.scss.shim.ngstyle.js.pre-build-optimizer.js